import { DatePipe, NgIf, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { PaypalService } from '../../paypal-login/paypal.service';
import { UserProfileService } from '../user-profile.service';

@Component({
    selector: 'app-manage-billing',
    templateUrl: './manage-billing.component.html',
    styleUrls: ['./manage-billing.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgStyle],
})
export class ManageBillingComponent implements OnInit {

  screenWidth: number;
  public payments: any[];
  public currentPlanPrice: any;
  public currentPlanDescription: String;
  public currentPlanSubscription: any;
  private username: string;
  private errorMessage:"";
  APP_SETTINGS:any;
  constructor(private userProfileService: UserProfileService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private paypalService:PaypalService,
    public datepipe: DatePipe) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.currentPlanSubscription = "";
    this.currentPlanPrice = "0";

    this.payments = [];
    this.username = this.authService.getUserName();

    this.spinnerService.show('bmwSpinner');
   this.paypalService.getActiveSubcription(this.username).subscribe(data => {
      if (data ) {
        this.currentPlanSubscription = data ;
        this.currentPlanPrice = this.currentPlanSubscription.tisSubscription.price ;
        this.currentPlanDescription = this.currentPlanSubscription.tisSubscription.description + " expiring on " + this.datepipe.transform(this.currentPlanSubscription.subscriptionEnd, 'yyyy-MM-dd');
      } 
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.errorMessage = error.error.message;
    });
    /*
    this.userProfileService.getBillingInfo(this.username).subscribe(data => {
      this.payments = data;
      this.payments.sort((a, b) => {
        if (a['paymentDate'] < b['paymentDate']) {
          return 1;
        } else if (a['paymentDate'] > b['paymentDate']) {
          return -1;
        } else {
          return 0;
        }
      });
      

      //Ganesan - 10/01/2018 - Commented for now as it was throwing nullpointer exception
      //this.currentPlanPrice = this.payments[0]['paymentGross'];
      //this.currentPlanSubscription = this.currentPlanPrice === 2500 ? " Year " : this.currentPlanPrice === 250 ? " Month " : " Day ";
    
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
      }); */
  }

}
